import { PARTNERS_PATH } from 'cpmWorkspaces/navigation';

module.exports = {
  path: PARTNERS_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/PartnersList'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/cpm/routes/workspaces/routes/show/routes/partners/index.js